<template>
    <div>
        <page-title>插件版本信息</page-title>
        <page-body>
            <div style="margin-bottom: 20px;" flex="cross:center" v-if="plugin">
                <div style="margin-right: 10px;">
                    <img :src="plugin.pic_url"
                         style="width: 40px;height: 40px;border-radius: 3px; display: block;">
                </div>
                <div style="line-height: 1.45;height: 40px;" flex="dir:top box:last">
                    <div>{{plugin.display_name}}</div>
                    <div style="font-size: 12px;color: #909399;">{{plugin.name}}</div>
                </div>
            </div>
            <el-button v-if="plugin"
                       type="text"
                       @click="loadMasterVersionData"
                       :loading="LoadingMasterVersionData">
                获取master分支版本数据
            </el-button>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="版本号" prop="version">
                    <el-input v-model="form.version" placeholder="插件版本号，如1.2.1"/>
                </el-form-item>
                <el-form-item label="商城版本" prop="mall_version">
                    <el-input v-model="form.mall_version" placeholder="商城版本号，如4.3.32"/>
                </el-form-item>
                <el-form-item label="更新说明" prop="content">
                    <el-input v-model="form.content" placeholder="" type="textarea" :rows="5"/>
                </el-form-item>
                <el-form-item label="插件后端代码包" prop="src_file">
                    <app-upload v-model="form.src_file"
                                :data="{validator:'app\\models\\forms\\PluginVersionValidator',name:plugin?plugin.name:null}"
                                v-on:on-success="onSrcUploadSuccess"></app-upload>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '新增'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>

        <el-dialog title="Master分支版本数据" :visible.sync="showMasterVersionData" class="master-versions">
            <div v-if="masterVersionData" class="list">
                <div v-for="(item, index) in masterVersionData.list"
                     :key="index"
                     flex="box:last cross:center"
                     class="item">
                    <div>
                        <div class="ellipsis-1">版本：{{item.version}}</div>
                        <div class="ellipsis-1">说明：{{item.content}}</div>
                        <div class="ellipsis-1">代码：{{item.src_file}}</div>
                    </div>
                    <div>
                        <el-button type="text" @click="useMasterVersionData(index)">使用</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        const validateVersion = (rule, value, callback) => {
            if (!this.packageVersion || !value) {
                return callback()
            }
            if (this.packageVersion !== value) {
                return callback(new Error('版本号与代码包版本不符合，代码包版本号' + this.packageVersion))
            }
            return callback()
        }
        return {
            loading: false,
            btnLoading: false,
            detail: null,
            packageVersion: null,
            rules: {
                version: [
                    {required: true, message: '请填写版本号。'},
                    {validator: validateVersion}
                ],
                content: [
                    {required: true, message: '请填写更新内容。'}
                ],
                src_file: [
                    {required: true, message: '请上传后端代码包。'}
                ]
            },
            plugin: null,
            form: {
                id: null,
                plugin_id: null,
                version: '',
                mall_version: '',
                content: '',
                src_file: '',
                wxapp_file: ''
            },
            masterVersionData: null,
            LoadingMasterVersionData: false,
            showMasterVersionData: false
        }
    },
    created() {
        this.form.id = this.$route.query.id || null
        this.form.plugin_id = this.$route.query.plugin_id || null
        this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/plugin-version/detail',
                params: {
                    id: this.form.id,
                    plugin_id: this.form.plugin_id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.plugin = e.data.data.plugin
                    if (e.data.data.form) {
                        this.form = e.data.data.form
                    }
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        onSrcUploadSuccess(response) {
            this.packageVersion = response.data.validate.version
            if (!this.form.version) {
                this.form.version = this.packageVersion
            }
            if (!this.form.content) {
                this.form.content = this.packageVersion
            }
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'admin/plugin-version/edit',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.push('/dashboard/admin/plugin/version?plugin_id=' + this.form.plugin_id)
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        },
        loadMasterVersionData() {
            if (this.masterVersionData) {
                this.showMasterVersionData = true
                return
            }
            this.LoadingMasterVersionData = true
            axios({
                url: 'admin/plugin/master-version-data',
                params: {
                    name: this.plugin.name
                }
            }).then(e => {
                this.LoadingMasterVersionData = false
                this.showMasterVersionData = true
                if (e.data.code === 0) {
                    this.masterVersionData = e.data.data
                }
            }).catch(e => {
                this.LoadingMasterVersionData = false
            })
        },
        useMasterVersionData(index) {
            this.form.version = this.masterVersionData.list[index].version
            this.form.src_file = this.masterVersionData.list[index].src_file
            this.form.content = this.masterVersionData.list[index].content
            this.showMasterVersionData = false
        }
    }
}
</script>
<style lang="scss" scoped>
    .ellipsis-1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .master-versions {
        .item {
            border: 1px solid #e5e5e5;
            padding: 8px 10px;
            border-bottom-width: 0;

            > div:last-child {
                padding-left: 10px;
            }
        }

        .item:last-child {
            border-bottom-width: 1px;
        }
    }
</style>
